import * as React from 'react';

export function ProblemSection() {
  return (
    <section className="bp-problem">
      <style>{`
        .bp-problem {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .bp-problem-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .bp-problem h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .bp-problem .accent {
          font-size: 22px;
          font-weight: 600;
          color: #c53030;
          margin: 0 0 28px;
        }
        .bp-problem p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 20px;
        }
        .bp-problem .highlight {
          font-weight: 600;
          color: #1a1a1a;
        }
        .bp-fail-list {
          list-style: none;
          padding: 0;
          margin: 24px 0 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        .bp-fail-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 15px;
          color: #555;
          padding: 10px 14px;
          background: #fef2f2;
          border-radius: 8px;
        }
        .bp-fail-list li i {
          color: #c53030;
          font-size: 14px;
          flex-shrink: 0;
        }
        @media (max-width: 640px) {
          .bp-problem h2 {
            font-size: 24px;
          }
          .bp-fail-list {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="bp-problem-inner">
        <h2>Vivir en un barrio privado tiene muchas ventajas.</h2>
        <p className="accent">Conseguir frutas y verduras frescas no es una de ellas.</p>
        <p>
          El supermercado más cercano tiene productos de cámara, la verdulería queda lejos,
          y <span className="highlight">entre el trabajo y los chicos no hay tiempo de ir al mercado</span>.
        </p>
        <ul className="bp-fail-list">
          <li><i className="fa fa-times-circle" /> Supermercado con productos de cámara</li>
          <li><i className="fa fa-times-circle" /> Viaje largo hasta una buena verdulería</li>
          <li><i className="fa fa-times-circle" /> Compras apuradas, sin tiempo de elegir</li>
          <li><i className="fa fa-times-circle" /> Fruta que a los 2 días ya no sirve</li>
        </ul>
      </div>
    </section>
  );
}
